import React from 'react';

import {ProcessesFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import {ProcessPlatformFeatureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import notifications from 'notifications';
import {getProcessPlatformFeatureConfig} from 'processes/processes-platform/FeatureOptions';
import EditableDateField from 'ui-library/EditableDateField';
import {isValidDate, tryParseDate} from 'util/DateUtil';
import {readableTime} from 'util/DateUtil';

import {ProcessTaskFieldProps} from '../ProcessTaskDetailsPageConstants';

export function ScheduledOnField(props: ProcessTaskFieldProps): JSX.Element {
  const readableDate = props.processTask.scheduledOnDate
    ? readableTime(props.processTask.scheduledOnDate, {showTime: false})
    : 'None';

  return isFeatureEnabled({feature: ProcessesFeature.PROCESSES_EDIT, item: props.processTask}) ? (
    <EditableDateField
      onChange={async (selectedDate) => {
        if (isValidDate({textValue: selectedDate})) {
          await props.onUpdateTask({id: props.processTask.id, scheduledOnDate: tryParseDate(selectedDate)});
        } else {
          notifications.error(
            'Date entered is invalid. Date must have format of (YYYY-MM-DD). Please try again.'
          );
        }
      }}
      value={props.processTask.scheduledOnDate}
      isDisabled={
        !getProcessPlatformFeatureConfig(
          ProcessPlatformFeatureType.CAN_EDIT_SCHEDULED_ON_DATE,
          props.processTask.schema.executionType,
          props.processTask.schema.name
        ) || !isFeatureEnabled({feature: ProcessesFeature.PROCESSES_EDIT, item: props.processTask})
      }
      placeholder="None"
    />
  ) : (
    <span className="editableField">{readableDate}</span>
  );
}
